import { Routes } from '@angular/router';

import { TaRoutes } from '@ta/menu';
import { AuthGuard, FeatureGuard } from '@ta/user';

export enum ESubscriptionRoute {
  subscription = 'subscription',
  overview = 'overview',
  history = 'history',
  /** Boost : option ponctuelle, sans renouvellement, indépendante de la cadence de l'abonnement. */
  boost = 'boost',
  /** Écran d'attente après un checkout Mollie. */
  paymentCallback = 'paymentCallback',
}

TaRoutes.addRoute({
  key: ESubscriptionRoute.subscription,
  url: 'subscription',
  children: [
    {
      key: ESubscriptionRoute.overview,
      url: 'overview',
    },
    {
      key: ESubscriptionRoute.history,
      url: 'history',
    },
    {
      key: ESubscriptionRoute.boost,
      url: 'boost',
    },
  ],
});

TaRoutes.addRoute({
  key: ESubscriptionRoute.paymentCallback,
  url: 'payment/callback',
});

export const subscriptionRoutes: Routes = [
  {
    path: TaRoutes.getUrl([ESubscriptionRoute.subscription, ESubscriptionRoute.overview]),
    title: 'app.pages.subscription.title',
    loadComponent: () =>
      import('./pages/subscription/subscription').then((c) => c.SubscriptionPage),
    canActivate: [AuthGuard, FeatureGuard],
    data: { feature: 'subscription', level: 'authorize' },
  },
  {
    path: TaRoutes.getUrl([ESubscriptionRoute.subscription, ESubscriptionRoute.history]),
    title: 'app.pages.subscription_history.title',
    loadComponent: () =>
      import('./pages/billing-history/billing-history-page').then((c) => c.BillingHistoryPage),
    canActivate: [AuthGuard, FeatureGuard],
    data: { feature: 'subscription', level: 'authorize' },
  },
  {
    path: TaRoutes.getUrl([ESubscriptionRoute.subscription, ESubscriptionRoute.boost]),
    title: 'app.pages.boost.title',
    loadComponent: () => import('./pages/boost/boost').then((c) => c.BoostPage),
    canActivate: [AuthGuard, FeatureGuard],
    data: { feature: 'subscription', level: 'authorize' },
  },
];
